import { LocationCode } from '@geneplanet/ngx-utils/src/lib/localization';
import { environment } from 'src/environments/environment';

type FeatureFlag = boolean | Partial<Record<LocationCode, boolean>>;

const features: Record<string, FeatureFlag> = environment.features;

export const isFeatureActive = (
  locationCode: LocationCode,
  featureName: string
): boolean => {
  const feature = features[featureName];

  // By default feature is active
  if (feature === undefined) {
    return true;
  }

  // It's localized
  if (typeof feature === 'object') {
    return feature[locationCode] !== false;
  }

  return feature;
};
